
import Swiper from 'https://unpkg.com/swiper@8/swiper-bundle.esm.browser.min.js';

class Publicacoes
{
	Carrosel()
	{
		const swiper = new Swiper('#SwiperPublicacoes', 
		{
			slidesPerView: 4,
			spaceBetween: 20,
			speed: 1000,
			navigation: false,
			// loop: false,
			pagination: {
				el: '#CCPublicacoes .swiper-pagination',
				clickable: true,
			},
			breakpoints: 
			{
				0: {
                    slidesPerView: 'auto',
					spaceBetween: 14,
				},
				568: {
					spaceBetween: 14,
					slidesPerView: 4,
				},
				992: {
					spaceBetween: 20,
					slidesPerView: 4,
				}
			}
		});
	}

	init(options)
	{
		const self = this;

        if ($("#SwiperPublicacoes").length > 0)
    	{
			self.Carrosel();
		}

        $(window).resize(function()
		{
            if ($("#SwiperPublicacoes").length > 0)
            {
                self.Carrosel();
            }
		});
	}
}

export default Publicacoes;